import { Y as url, S as getNavigationState } from './utils-15ad90ec.js';
import { i as isV3, j as getBrandName } from './lookups-705fb53e.js';
import { j as join } from './path-9b025204.js';
import './request.constants-deb285e0.js';

const getSelectorConfigUrl = (host, rangeId, isHostAbsolutePath) => {
  const localArr = host.split('/');
  const countryCode = localArr[localArr.length - 2];
  const languageCode = localArr[localArr.length - 1];
  const brandName = getBrandName();
  if (isV3()) {
    return `/ranges/${rangeId}/selector-config?country-code=${countryCode}&language-code=${languageCode}&brand=${brandName}`;
  }
  if (isHostAbsolutePath) {
    return `${host}/${join('product/range/selector-config', rangeId)}`;
  }
  return join(host, 'product/range/selector-config', rangeId);
};
const getFiltersUrl = (host, endpoint, rangeId, navigationState, nodeId, categoryId) => url.format({
  pathname: join(host, endpoint, 'api/range/filters', rangeId, nodeId || '', categoryId || ''),
  query: Object.assign({}, (navigationState.includes('subnode-id')
    ? { 'subnode-id': navigationState.replace('?subnode-id=', '') }
    : { n: getNavigationState(navigationState) })),
});

export { getSelectorConfigUrl as a, getFiltersUrl as g };
